import { Thumbnail } from "@shopify/polaris";
import styles from "./RenderPages.module.css";
import { CloseIcon } from "../../apps/Bundles/BundleBuilder/BundleBuilderBundle/BundleBuilderBundle";
import { CollectionIcon } from "@shopify/polaris-icons";

const RenderPages = ({
    show_offer_cta_pages,
    removeProduct = () => {},
    type = "products",
}: {
    type: "products" | "collections";
    show_offer_cta_pages: any;
    removeProduct: any;
}) => {
    return (
        <span
            style={{
                display: "flex",
                flexDirection: "column",
                maxHeight: 150,
                overflowY: "auto",
                width: "100%",
                border: "1px dashed var(--p-color-border)",
                borderRadius: "var(--p-border-radius-300)",
                padding: 15,
                gap: 5,
            }}
        >
            {show_offer_cta_pages?.value?.map((product: any, pIdx: number) => {
                if (type == "products") {
                    return (
                        <div className={styles.productMeta} key={product?.variants[0]?.id + pIdx}>
                            <div className={styles.productName}>
                                <div className={styles.productImageWrapper}>
                                    <Thumbnail
                                        alt={product?.images[0]?.altText}
                                        source={product?.images[0]?.originalSrc}
                                    />
                                </div>
                                <div className={styles.productTitleWrapper}>
                                    <div
                                        style={{
                                            whiteSpace: "normal",
                                            cursor: "pointer",
                                            textDecoration: "underline",
                                        }}
                                        onClick={() => {
                                            if (shopify.config.shop) {
                                                window.open(
                                                    `https://${shopify.config.shop}/products/${product?.handle}`,
                                                    "_blank",
                                                );
                                            }
                                        }}
                                        className={styles.productTitle}
                                    >
                                        {product?.title}
                                    </div>
                                </div>
                            </div>
                            <div
                                onClick={() => {
                                    removeProduct(product?.id);
                                }}
                                style={{
                                    cursor: "pointer",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    marginRight: 10,
                                }}
                            >
                                <CloseIcon />
                            </div>
                        </div>
                    );
                } else {
                    return (
                        <div className={styles.productMeta} key={product?.title + pIdx}>
                            <div className={styles.productName}>
                                <div className={styles.productImageWrapper}>
                                    <Thumbnail
                                        source={product?.image?.originalSrc || CollectionIcon}
                                        alt={product?.title}
                                        size={"small"}
                                    />
                                </div>
                                <div className={styles.productTitleWrapper}>{product?.title}</div>
                            </div>

                            <div
                                onClick={() => {
                                    removeProduct(product?.id);
                                }}
                                style={{
                                    cursor: "pointer",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    marginRight: 10,
                                }}
                            >
                                <CloseIcon />
                            </div>
                        </div>
                    );
                }
            })}
        </span>
    );
};

export default RenderPages;
